var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('boolean-field',{attrs:{"id":_vm.id,"label":_vm.label,"name":`filter:${_vm.filterGroup}:${_vm.name}:equal`,"refresh-fields":_vm.refreshFields,"value":_vm.value},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }